import axios from "axios";
import authHeader from "./AuthHeader";
import AuthService from "../service/AuthService";

const api_url = process.env.REACT_APP_URL;
const slug = AuthService.getLng() + "/tirebooking/calendar/";
const bodyParameters = {};

export class CalendarService {

  getCalendars(id) {
    return axios
      .get(api_url + slug + '?active=true&ctype=2,3', {
        headers: authHeader(),
      })
      .then((res) => res.data.results);
  }

  getCalendarsByWh(id) {
    return axios
      .get(api_url + slug + '?active=true&ctype=2,3&warehouse=' + id, {
        headers: authHeader(),
      })
      .then((res) => res.data.results);
  }


}
